var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.972 8.972 0 20 0C24.4539 0 28.6695 1.43295 32.1912 4.144L27.5436 10.1813C25.3661 8.50514 22.7575 7.61905 20 7.61905C13.1731 7.61905 7.61905 13.1731 7.61905 20C7.61905 26.8269 13.1731 32.381 20 32.381C25.4985 32.381 30.171 28.7785 31.7813 23.8095H20V16.1905H40V20C40 31.028 31.028 40 20 40C8.972 40 0 31.028 0 20Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4146b529758548c893f35982e3efd080.svg";
export { ForwardRef as ReactComponent };